module.exports = __webpack_public_path__ + "img/icn_confirmation.7a00b6c3.svg";